/* PB STRAP ATTACH engine (PB-1159), for sections/pb-strap-attach.liquid.
   Re-bootable: boots every [data-pbsa] not booted yet, on load and on theme-editor section loads.
   Scroll-linked, transform/opacity only; one rAF loop that runs only while the eased progress catches up;
   no live innerHeight in the maths (measured once, re-measured on a width change or a big height jump);
   nothing runs off screen; reduced motion or no JS = the four static frames. */
(function () {
  if (window.__pbsaBoot) { window.__pbsaBoot(); return; }
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a)); };
  var outC = function (t) { return 1 - Math.pow(1 - t, 3); };
  var inOut = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var LERP_K = 0.22;
  /* the timeline, in track progress 0..1. Owner [src M-9DCA]: exactly 3 steps: 1. tether (the wide tab on the
     phone's back, where the case will hold it, loop out of the bottom), 2. put the phone case on, 3. clip on.
     No sway, bounce or pulse: every part moves one way with the scroll, so a flick never shakes.
     PB-1249: the clip is a lobster clasp: its gate opens as the claw comes up, the claw hooks the tab's D-ring and the
     gate snaps shut [src M-32FF]; the swivel then turns a full turn under the straps (they stay still: nothing
     twists); zoomed back out, the phone turns over to hang below the clip, the rotation of PB-1159 [src M-80E2].
     The close-up zoom is capped so the case never runs past the stage edges [src M-D62D]. */
  var T = {
    tab: [0.04, 0.22],                /* 1. the wide tab slides onto the bottom of the phone's back */
    caseIn: [0.3, 0.46],              /* 2. the case goes on over phone and tab, loop still out of the port */
    zoomIn: [0.5, 0.63],              /* 3. close-up on the loop */
    strap: [0.56, 0.71],              /*    strap rises, the claw comes up to the loop */
    gateOpen: [0.6, 0.66], gateShut: [0.71, 0.735], click: [0.71, 0.77],   /* gate opens, hooks, snaps shut */
    spin: [0.75, 0.83],               /*    the swivel turns a full turn */
    zoomOut: [0.8, 0.9],              /*    back out */
    flip: [0.88, 0.99],               /*    the phone turns over and hangs below the clip */
    caps: [0.26, 0.49]
  };
  /* canvas units (400 x 900), from tools/acc-stories/strap-fix/layers_v2.py geometry.json */
  var PX = 195.6, PY = 664.7, PHONE_CY = 330, PHONE_H = 600, CASE_W = 292, ZOOM = 1.85, ZOOM_FY = 650;
  var CASE_FULL = 304, GATE_OPEN = 30, HANG_Y = 0.24;   /* case outer width with its stroke; gate swing (deg); hang point */
  function boot(root) {
    if (root.__pbsa) return; root.__pbsa = 1;
    if (RM) return;                                   /* the static frames stand */
    var track = root.querySelector('[data-track]'), scene = root.querySelector('[data-scene]'),
        stage = root.querySelector('[data-stage]');
    if (!track || !scene || !stage) return;
    var rig = stage.querySelector('[data-rig]'), tab = stage.querySelector('[data-tab]'),
        cas = stage.querySelector('[data-case]'), strap = stage.querySelector('[data-strap]'),
        click = stage.querySelector('[data-click]'), caps = root.querySelectorAll('[data-cap]'),
        dots = root.querySelectorAll('[data-dot]'),
        spin = stage.querySelector('[data-spin]'), gate = stage.querySelector('[data-gate]');
    if (!rig || !tab || !cas || !strap) return;
    root.classList.add('is-live');
    var G = { total: 1, sw: 0, sh: 0, vw: 0, vh: 0, u: 0.5 };
    var near = false, raf = false, pS = -1, pLast = 0, lastP = -2, lastCap = -1;

    var top0 = 0, dpr = window.devicePixelRatio || 1;
    var px = function (v) { return Math.round(v * dpr) / dpr; };      /* snap to device pixels: no subpixel shimmer */
    function measure() {
      G.vw = window.innerWidth; G.vh = window.innerHeight;  /* read once, only here */
      top0 = track.getBoundingClientRect().top + window.pageYOffset; /* cached: no layout reads while scrolling */
      G.total = Math.max(1, track.offsetHeight - scene.offsetHeight);
      G.sw = stage.offsetWidth; G.sh = stage.offsetHeight;
      G.u = Math.min(0.6 * G.sh / PHONE_H, 0.8 * G.sw / CASE_W);
      G.z = Math.max(1, Math.min(ZOOM, 0.92 * G.sw / (CASE_FULL * G.u)));   /* close-up never wider than the stage */
      lastP = -2;
    }
    function onResize() {
      var w = window.innerWidth, h = window.innerHeight;
      if (w === G.vw && Math.abs(h - G.vh) <= 150) return;   /* Safari toolbar: height-only wobble, ignore */
      measure(); kick();
    }
    function tr(y) { return 'translate3d(0,' + px(y) + 'px,0)'; }
    function render(p) {
      if (Math.abs(p - lastP) < 0.0002) return; lastP = p;
      var u = G.u, sw = G.sw, sh = G.sh;
      /* 1. the tab slides up onto the base of the phone's back */
      var t1 = seg(p, T.tab[0], T.tab[1]);
      tab.style.transform = tr(300 * (1 - outC(t1)));
      tab.style.opacity = Math.min(1, t1 * 3).toFixed(3);
      /* 2. the case slides down over phone and tab */
      var t2 = seg(p, T.caseIn[0], T.caseIn[1]);
      cas.style.transform = tr(-760 * (1 - outC(t2)));
      cas.style.opacity = Math.min(1, t2 * 4).toFixed(3);
      /* 3. strap rises from below and clicks on */
      var rise = outC(seg(p, T.strap[0], T.strap[1]));
      strap.style.transform = tr((220 + sh / (u * 0.9)) * (1 - rise));
      strap.style.opacity = rise > 0 ? '1' : '0';
      if (gate) {   /* lobster clasp: the gate swings in as the claw arrives, then snaps shut once it is round the ring */
        var go = outC(seg(p, T.gateOpen[0], T.gateOpen[1])) * (1 - outC(seg(p, T.gateShut[0], T.gateShut[1])));
        gate.style.transform = 'rotate(' + (GATE_OPEN * go).toFixed(2) + 'deg)';
      }
      if (spin) {   /* the swivel turns once: seen side on, a turn is a squash through its edge and back */
        var sp = inOut(seg(p, T.spin[0], T.spin[1])), sx = Math.cos(Math.PI * 2 * sp);
        if (Math.abs(sx) < 0.06) sx = sx < 0 ? -0.06 : 0.06;
        spin.style.transform = sp > 0 && sp < 1 ? 'scale(' + sx.toFixed(3) + ',1)' : 'none';
      }
      if (click) {
        var cj = seg(p, T.click[0], T.click[1]);
        click.style.opacity = (cj > 0 && cj < 1 ? Math.sin(Math.PI * cj) : 0).toFixed(3);
      }
      /* the camera: focus point F (canvas) at screen point Q, scale S */
      var zo = inOut(seg(p, T.zoomOut[0], T.zoomOut[1]));
      var z = inOut(seg(p, T.zoomIn[0], T.zoomIn[1])) * (1 - zo);
      var f = inOut(seg(p, T.flip[0], T.flip[1]));
      var fy = PHONE_CY + (ZOOM_FY - PHONE_CY) * z, S = u * (1 + (G.z - 1) * z) * (1 - 0.14 * zo) * (1 - 0.12 * f);
      var qy = sh / 2 - 0.1 * sh * z + (PY - fy) * S;          /* the pivot (hook) on screen */
      qy = qy + (sh * 0.66 - qy) * zo;                           /* lifted so the strap shows */
      qy = qy + (sh * HANG_Y - qy) * f;                          /* turned over: the clip near the top, the phone hanging below */
      rig.style.transform = 'translate3d(' + px(sw / 2) + 'px,' + px(qy) + 'px,0)' + (f > 0 ? ' rotate(' + (180 * f).toFixed(2) + 'deg)' : '') +
        ' scale(' + S.toFixed(4) + ') translate(' + -PX + 'px,' + -PY + 'px)';
      /* captions: switch while that step's art is on screen */
      var ci = 0; while (ci < T.caps.length && ci < caps.length - 1 && p >= T.caps[ci]) ci++;
      if (ci !== lastCap) {
        lastCap = ci;
        for (var i = 0; i < caps.length; i++) {
          caps[i].style.opacity = i === ci ? '1' : '0';
          if (dots[i]) { dots[i].style.opacity = i === ci ? '1' : i < ci ? '.45' : '.18'; }
        }
      }
    }
    function frame(ts) {
      raf = false;
      var pT = clamp((window.pageYOffset - top0) / G.total);
      var y = window.pageYOffset, live = y + G.vh > top0 && y < top0 + G.total + G.vh;
      var dt = pLast ? Math.min(64, Math.max(0, ts - pLast)) : 16; pLast = ts;
      if (pS < 0 || !live) pS = pT;
      else { var d = pT - pS; pS = Math.abs(d) < 0.0004 ? pT : pS + d * (1 - Math.pow(1 - LERP_K, dt / 16.67)); }
      render(pS);
      if (pS !== pT && near) kick(); else if (pS === pT) pLast = 0;
    }
    function kick() { if (!raf) { raf = true; requestAnimationFrame(frame); } }
    function onScroll() { if (near) kick(); }

    measure(); render(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        near = es[0].isIntersecting; root.classList.toggle('is-active', near);
        if (near) { measure(); kick(); }
      }, { rootMargin: '50% 0px 50% 0px' }).observe(root);
    } else { near = true; }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', function () { measure(); kick(); });
    if ('ResizeObserver' in window) {
      var lastBH = 0;
      new ResizeObserver(function () { var bh = document.body.offsetHeight; if (bh !== lastBH) { lastBH = bh; measure(); kick(); } }).observe(document.body);
    }
    window.addEventListener('pageshow', function () { measure(); pS = -1; kick(); });
    root._pbsaP = function () { return pS; };
    root._pbsaSet = function (p) { pS = p; lastP = -2; render(p); };   /* for tests: pose a frame */
  }
  function bootAll() { [].forEach.call(document.querySelectorAll('[data-pbsa]'), boot); }
  window.__pbsaBoot = bootAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
